import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class MoreIcon extends BaseIcon {
  getChildren = () => [<path d="M0 0h24v24H0z" fill="none" />, <path fill={this.getColor()}
    d='M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' />]
  getViewBox = () => '4 4 16 16'
}
